import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import './Share.scss';

const Share = ({ headerRef }) => {
  function hideShare() {
    shareInnerRef.current.classList.remove('visshare');
    showShareRef.current.classList.add('isShare');
    shareContainerRef.current.classList.remove('vissc');
    headerRef.current.classList.remove('vis-header-b');
  }

  function showShare() {
    shareInnerRef.current.classList.add('visshare');
    showShareRef.current.classList.remove('isShare');
    setTimeout(() => {
      headerRef.current.classList.add('vis-header-b');
      shareContainerRef.current.classList.add('vissc');
    }, 400);
  }

  const shareInnerRef = useRef();
  const shareContainerRef = useRef();
  const showShareRef = useRef();
  return null;
  return (
    <>
      <div
        ref={showShareRef}
        onClick={event => {
          event.preventDefault();
          showShareRef.current.classList.contains('isShare')
            ? showShare(shareInnerRef.current, shareContainerRef.current, showShareRef.current, headerRef.current)
            : hideShare(shareInnerRef.current, shareContainerRef.current, showShareRef.current, headerRef.current);
        }}
        className="show-share isShare"
      >
        <i className="fa fa-share-alt" />
      </div>
      <div ref={shareInnerRef} className="share-inner">
        <div className="share-container  isShare" ref={shareContainerRef} data-share="['facebook','twitter','linkedin']" />
        <div className="close-share" />
      </div>
    </>
  );
};

Share.propTypes = {
  headerRef: PropTypes.object.isRequired
};

export default Share;
